import { api } from "../client";

export const getCustomUtilization = (params) => {
  const { dateFrom, dateTo, floorName, excludeDepartments, filterZones } = params;

  const queryParams = new URLSearchParams();
  // API expects 'from' and 'to', not 'dateFrom' and 'dateTo'
  queryParams.append("from", dateFrom);
  queryParams.append("to", dateTo);

  if (floorName && floorName !== "all") {
    queryParams.append("floorName", floorName);
  }

  if (excludeDepartments && excludeDepartments.length > 0) {
    queryParams.append("excludeDepartments", excludeDepartments.join(","));
  }

  if (filterZones && filterZones.length === 1) {
    queryParams.append("filterZones", filterZones.join(","));
  }

  return api.get(`/api/utilization/custom?${queryParams}`);
};
